import autoOffer from './auto-offer.module'
import pricingLineup from './lineup.module'

export default {
  autoOffer,
  pricingLineup,
}
